import styled from "styled-components";

export const TimePickerWrapper = styled.div`
  width: 100%;
`;

export const OptionWrapper = styled.div`
  .selected {
    .fui-Option__checkIcon {
      visibility: visible;
    }
  }
`;
